'use strict';

import React, { Component, Fragment } from 'react';
import is from 'is_js';
import uniqid from 'uniqid';
import numeral from 'numeral';
import TextInput from 'Components/Forms/Elements/TextInput';
import FileInput from 'Components/Forms/Elements/FileInput';
import TextEditor from 'Components/Forms/Elements/TextEditor';
import Select from 'Components/Forms/Elements/Select';
import MultiSelect from 'Components/Forms/Elements/MultiSelect';
import DatePicker from 'Components/Forms/Elements/DatePicker';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import DeleteIcon from '@material-ui/icons/Delete';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import handleChange from 'Components/Forms/Functions/handleChange';
import handleFileChange from 'Components/Forms/Functions/handleFileChange';
import getStateFromObject from 'Components/Forms/Functions/getStateFromObject';
import getFormData from 'Components/Forms/Functions/getFormData';
import { coworking_place_types as types } from 'Shared/options';
import bemit from 'Functions/bemit';
import Loader from 'Pure/Loader';
import { action } from 'Shared/Routes';
let app = window.app;
const qwest = window.qwest;
export default class PackOrderIndexForm extends Component {
  state = {
    status_messages: {}
  };
  handleChange = handleChange.bind(this);
  componentDidMount() {
    const component = this,
      props = this.props,
      state = this.state;
    component.fetchPackOrderIndex();
  }
  fetchPackOrderIndex = () => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      loading: true
    });
    qwest.post(action('getAllPackOrdersIndex'), {
      id: props.id || document.location.pathname.split('/liste-des-packs-achetes/')[1],
      with_count: false
    }).then(function (xhr, response) {
      const update = getStateFromObject({
        data: response.data[0],
        model: 'packorderindex'
      });
      component.setState({
        ...update,
        loading: false
      });
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  validate = e => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading === true) return;
    component.setState({
      loading: true
    });
    const packorderindex = getFormData({
      state: state,
      pattern: 'packorderindex['
    });
    qwest.post(action('updatePackOrderIndex'), packorderindex).then(function (xhr, response) {
      component.setState({
        loading: false,
        info: response.info,
        error: undefined,
        warning: undefined,
        status_messages: {}
      });
      if (props.type !== 'update') {
        component.clearForm();
      }
      window.setTimeout(function () {
        app.navigateTo('/liste-des-packs-achetes');
      }, 1500);
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  clearForm = () => {
    const component = this,
      props = this.props,
      state = this.state;
    const update = Object.keys(state).filter(key => key.startsWith('packorderindex[')).reduce(function (update, key) {
      if (is.string(state[key])) {
        update[key] = '';
      } else if (is.array(state[key])) {
        update[key] = [];
      } else if (is.json(state[key])) {
        update[key] = {};
      }
      return update;
    }, {});
    component.setState(update);
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const status = getFormStatus(state);
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-primary']
    }) : undefined;
    let output = /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("form", {
      method: "POST",
      action: "/packorderindex/create",
      className: props.paper !== false ? 'c-paper' : undefined
    }, /*#__PURE__*/React.createElement(Grid, {
      container: true,
      spacing: 2
    }, /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(TextInput, {
      className: "u-full-width",
      name: 'packorderindex[remaining_credit]',
      onChange: component.handleChange,
      label: "Cr\xE9dit restant",
      value: state['packorderindex[remaining_credit]'],
      status: state.status_messages,
      "safe-value": true,
      int: true,
      inputMode: "numeric",
      min: "1"
    })), /*#__PURE__*/React.createElement(Grid, {
      item: true,
      xs: 12,
      sm: 6
    }, /*#__PURE__*/React.createElement(DatePicker, {
      onChange: component.handleChange,
      value: state['packorderindex[expiration_date]'] || "",
      className: "cutom-date-picker",
      name: "packorderindex[expiration_date]",
      label: "Date d'expiration",
      "allow-no-value": true,
      status: state.status_messages
    }))), status), /*#__PURE__*/React.createElement("div", {
      className: "u-full-width u-text-center\r u-margin-top-25 u-padding-bottom-20 "
    }, /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary']),
      onClick: component.validate
    }, "Mettre \xE0 jour", loader)));
    return output;
  }
}
